module.exports = __webpack_public_path__ + "img/index-qysl2.7eb09683.png";